import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ApplicationFacade, CustomerAccountsFacade } from '@ridango/components';

@Component({
    selector: 'gl-account-selector-dialog',
    templateUrl: './account-selector-dialog.component.html',
    styleUrls: ['./account-selector-dialog.component.scss']
})
export class AccountSelectorDialogComponent {
    assetsPath$ = this.applicationFacade.assetsPath$;
    accountsWithDisplayData$ = this.customerAccountsFacade.accountsWithDisplayData$;
    allAccountDataLoading$ = this.customerAccountsFacade.allAccountDataLoading$;
    locale = this.translate.currentLang;
    isContrast$ = this.applicationFacade.highContrast$;

    constructor(
        public dialogRef: MatDialogRef<AccountSelectorDialogComponent>,
        private applicationFacade: ApplicationFacade,
        private customerAccountsFacade: CustomerAccountsFacade,
        private translate: TranslateService
    ) {}

    onAccountSelect(accountId: string): void {
        this.customerAccountsFacade.selectCustomerAccount(accountId);
        this.dialogRef.close(accountId);
    }

    onClose(): void {
        this.dialogRef.close();
    }
}
